<template>
  <b-row
    v-show="show_player()"
    id="mainplayer"
    class="fixed-bottom "
    :class="{
      'player-expand': this.expand,
      'player-collapse': !this.expand,
      'player-hidden': this.hidden,
    }"
  >
    <b-col cols="12">
      <b-progress
        id="progress"
        class="w-100 rounded-0"
        variant="danger"
        :class="{
          bar: loadedSong,
          'bar-hide': !loadedSong,
          'bar-expand': barTapped,
          'bar-hoverable': true,
        }"
        @click.native.self="clickSeek"
        @touchstart.native="tapSeek"
        @mousedown.native="detectMouseDown"
        @mouseup.native="detectMouseUp"
        @mouseenter.native="barHover = true"
        @mouseleave.native="
          barHover = false;
          dragging = false;
        "
      >
        <b-progress-bar
          id="progress-fill"
          @click.native="barClick"
          @mousedown.native="detectMouseDown"
          @mouseup.native="detectMouseUp"
          :value="dragging ? trackProgressDrag : trackProgress"
          max:bind="player.duration()"
          style="transition: none"
        >
          <span class="text-left ml-3 player-label">
            <strong
              :class="{
                'player-label-hide': !barHover,
                'player-label': barHover,
              }"
              >{{ trackProgressMinutesSeconds }}</strong
            >
          </span>
        </b-progress-bar>
      </b-progress>
    </b-col>

    <b-container
      fluid
      class=" bg-dark"
      v-bind:class="{ 'border-top': !getLoadedSongData }"
      style="z-index:100;"
    ></b-container>

    <b-container fluid class="bg-dark">
      <b-container fluid class="d-flex flex-column bg-dark player-width">
        <b-row
          class="player-container text-center"
          @mouseenter="playerMouseEnter"
          @mouseleave="playerMouseLeave"
        >
          <b-col cols="1" md="1" lg="1" class="pl-3 align-self-center">
            <b-button
              v-if="!playing && !radio_stopped"
              @click="play"
              variant="link"
              class="p-0 float-left"
            >
              <img
                v-if="loadedSong"
                src="../assets/play-icon.svg"
                blank-color="#ccc"
                class="main-play-icon"
                alt="placeholder"
              />
              <img
                v-else
                src="../assets/player/play-icon-inactive.svg"
                blank-color="#ccc"
                class="main-play-icon"
                alt="placeholder"
              />
            </b-button>

            <!-- Restart Radio -->
            <b-button
              v-if="radio_stopped"
              @click="radio_restart"
              variant="link"
              class="p-0 float-left"
            >
              <img
                src="../assets/play-icon.svg"
                blank-color="#ccc"
                class="main-play-icon"
                alt="placeholder"
              />

            </b-button>


            <b-button
              v-if="playing && !getLoadedSongData.radio"
              @click="pause"
              variant="link"
              class="p-0 float-left"
            >
              <img
                src="../assets/pause-icon.svg"
                blank-color="#ccc"
                class="main-play-icon"
                alt="placeholder"
              />
            </b-button>

            <!-- Radio Stop -->
            <b-button
              v-else-if="playing && getLoadedSongData.radio"
              variant="link"
              class="p-0 float-left"
              @click="radio_stop"
            >
              <img
                src="../assets/pause-icon-disable.svg"
                blank-color="#ccc"
                class="main-play-icon"
                alt="placeholder"
              />
            </b-button>
          </b-col>

          <!-- Back / Repeat buttons -->
          <b-col
            cols="2"
            md="2"
            @click="back"
            class="align-self-center float-right mt-0 player-control-left"
          >
            <b-button variant="link" class="p-0">
              <img
                v-if="(playing || paused) && !getLoadedSongData.radio"
                src="../assets/player/back.svg"
                blank-color="#ccc"
                class="back-icon"
                alt="placeholder"
              />
              <img
                v-else
                src="../assets/player/back-inactive.svg"
                blank-color="#ccc"
                class="back-icon"
                alt="placeholder"
              />
            </b-button>
            
            <!-- Repeat Active -->
            <b-button
              @click="repeat"
              variant="link"
              class="p-0"
            >
              <img
                v-if="getRepeat"
                src="../assets/player/repeat.svg"
                blank-color="#ccc"
                class="repeat-icon"
                alt="placeholder"
              />

              <img
                v-else
                src="../assets/player/repeat-inactive.svg"
                blank-color="#ccc"
                class="repeat-icon"
                alt="placeholder"
              />
            </b-button>
            
          </b-col>

          <!-- Display song data when playing or paused  -->
          <b-col
            v-if="playing || paused"
            cols="6"
            md="6"
            lg="6"
            class="align-self-center"
          >
            <img
              v-if="!expand"
              src="../assets/arrow-up.svg"
              blank-color="#ccc"
              height="8"
              class="mt-2 nav-arrow"
              alt="placeholder"
              @click="expand = true"
              style="cursor:pointer;"
            />
            <img
              v-if="expand"
              src="../assets/nav-down.svg"
              blank-color="#ccc"
              height="8"
              class="mt-2 nav-arrow"
              alt="placeholder"
              @click="expand = false"
              style="cursor:pointer;"
            />

            <div class="text-light pt-2 mb-1 song-info-xs">
              <router-link :to="{ name: 'Song', params: { id: getLoadedSongData.id } }"  class="text-light">
                <p class="song-name mb-0">{{ getLoadedSongData.title }}</p>
              </router-link>
              <router-link :to="{ name: 'ArtistUsername', params: { id: getLoadedSongData.username } }" class="text-light">
                <p class="song-artist-name">{{ getLoadedSongData.username }}</p>
              </router-link>
            </div>

            <b-row
              class="text-light song-info"
              align-v="center"
              :class="{
                'song-info-adjust':
                  getLoadedSongData.title &&
                  getLoadedSongData.title.length <= getMaxTextLength,
                'marquee-adjust':
                  getLoadedSongData.title &&
                  getLoadedSongData.title.length > getMaxTextLength,
              }"
            >
              <b-col id="song_name_container" cols="6" class="pl-0 pr-0">
                <!-- <p class="text-light pt-2 mb-1 song-info"> -->
                <div
                  id="song_name"
                  class="song-name"
                  :class="{
                    marquee:
                      getLoadedSongData.title &&
                      getLoadedSongData.title.length > getMaxTextLength,
                  }"
                >
                  <div class="text-right">
                    
                    <img 
                      v-if="getLoadedSongData.radio && getLoadedSongData.locked"
                      src="../assets/chipin+-locked-light.svg" height="20" style="transform: translate(-5px, -2px)"/>

                    <router-link 
                      :to="{ name: 'Song', params: { id: getLoadedSongData.id } }" 
                      class="text-light" 
                      style="text-decoration:none;"
                      >
                        {{ getLoadedSongData.title }}
                    </router-link>
                  </div>
                </div>
              </b-col>
              <b-col
                cols="6"
                id="artist_name_container"
                class="text-left pr-0"
                :class="{
                  'artist-name-adjust':
                    getLoadedSongData.title &&
                    getLoadedSongData.title.length > getMaxTextLength,
                }"
              >
                
                <router-link :to="{ name: 'ArtistUsername', params: { id: getLoadedSongData.username } }" >
                  <span class="song-artist-name px-0 text-light">- {{
                    getLoadedSongData.username
                  }}</span>
                </router-link>
              </b-col>
            </b-row>
          </b-col>

          <!-- If the player is idle -->
          <b-col
            v-if="!playing && !paused"
            cols="6"
            md="6"
            lg="6"
            class="text-center align-self-center select-track-section"
          >
            <div>
              <img
                v-if="!expand"
                src="../assets/arrow-up.svg"
                blank-color="#ccc"
                height="8"
                class="mb-2 mt-0 nav-arrow"
                alt="placeholder"
                @click="expand = true"
                style="cursor:pointer;"
              />
              <img
                v-else
                src="../assets/nav-down.svg"
                blank-color="#ccc"
                height="8"
                class="mb-2 mt-0 nav-arrow"
                alt="placeholder"
                @click="expand = false"
                style="cursor:pointer;"
              />
              <p class="select-track mt-0">Select Track</p>
            </div>
          </b-col>

          <!-- Forward / Shuffle Buttons -->
          <b-col
            cols="2"
            class="align-self-center float-left mt-0 player-control-right"
          >
            <!-- Shuffle Active -->
            <b-button
              v-if="isShuffled"
              @click="shuffle"
              variant="link"
              class="p-0"
            >
              <img
                src="../assets/player/shuffle.svg"
                blank-color="#ccc"
                class="shuffle-icon"
                alt="placeholder"
              />
            </b-button>
            <!-- Shuffle Inactive -->
            <b-button v-else @click="shuffle" variant="link" class="p-0">
              <img
                src="../assets/player/shuffle-inactive.svg"
                blank-color="#ccc"
                class="shuffle-icon"
                alt="placeholder"
              />
            </b-button>

            <b-button
              v-if="!getLoadedSongData.radio && (playing || paused)"
              @click="forward"
              variant="link"
              class="p-0 "
            >
              <img
                src="../assets/player/forward.svg"
                blank-color="#ccc"
                class="forward-icon"
                alt="placeholder"
              />
            </b-button>
            <b-button
              v-else-if="(playing || paused) && getRemainingSkips > 0"
              @click="forward"
              variant="link"
              class="p-0 "
            >
              <img
                src="../assets/player/forward.svg"
                blank-color="#ccc"
                class="forward-icon"
                alt="placeholder"
              />
            </b-button>
            <b-button v-else variant="link" class="p-0 ">
              <img
                src="../assets/player/forward-inactive.svg"
                blank-color="#ccc"
                class="forward-icon"
                alt="placeholder"
              />
            </b-button>
          </b-col>
        </b-row>

        <b-row
          class="text-center nav-margin"
          align-v="end"
          :class="{
            'player-expand': this.expand,
            'player-collapse': !this.expand,
            'player-hidden': this.hidden,
          }"
        >
          <b-col cols="4">
            <b-button
              variant="link"
              style="text-decoration:none;"
              :to="{
                name: 'LibraryArea',
                params: { area: 'create', name: 'Library' },
              }"
              v-if="whatUserType() === 'creator' && isAuthenticated"
            >
              <!-- TODO: install webpack to use some svg extractor -->
              <svg
                class="nav-icon"
                viewBox="0 0 45 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-bind:class="{
                  'c-selected-menu':
                    this.$route.name && this.$route.name.includes('Library'),
                }"
              >
                <path
                  d="M10.713 0.000102571C10.584 -0.00181952 10.4559 0.0232894 10.3361 0.0739701C10.2163 0.124651 10.1073 0.199892 10.0154 0.295322C9.92352 0.390752 9.85054 0.504467 9.80073 0.629859C9.75091 0.755251 9.72526 0.889818 9.72526 1.02574C9.72526 1.16166 9.75091 1.29623 9.80073 1.42162C9.85054 1.54701 9.92352 1.66073 10.0154 1.75616C10.1073 1.85159 10.2163 1.92683 10.3361 1.97751C10.4559 2.02819 10.584 2.0533 10.713 2.05138H34.087C34.216 2.0533 34.3441 2.02819 34.4639 1.97751C34.5837 1.92683 34.6927 1.85159 34.7846 1.75616C34.8765 1.66073 34.9495 1.54701 34.9993 1.42162C35.0491 1.29623 35.0747 1.16166 35.0747 1.02574C35.0747 0.889818 35.0491 0.755251 34.9993 0.629859C34.9495 0.504467 34.8765 0.390752 34.7846 0.295322C34.6927 0.199892 34.5837 0.124651 34.4639 0.0739701C34.3441 0.0232894 34.216 -0.00181952 34.087 0.000102571H10.713ZM5.84348 4.10266C5.71442 4.10073 5.58629 4.12584 5.46653 4.17652C5.34677 4.2272 5.23777 4.30245 5.14586 4.39788C5.05396 4.49331 4.98097 4.60702 4.93116 4.73241C4.88135 4.8578 4.85569 4.99237 4.85569 5.12829C4.85569 5.26422 4.88135 5.39879 4.93116 5.52418C4.98097 5.64957 5.05396 5.76328 5.14586 5.85871C5.23777 5.95414 5.34677 6.02939 5.46653 6.08007C5.58629 6.13075 5.71442 6.15586 5.84348 6.15393H38.9565C39.0856 6.15586 39.2137 6.13075 39.3335 6.08007C39.4532 6.02939 39.5622 5.95414 39.6541 5.85871C39.746 5.76328 39.819 5.64957 39.8688 5.52418C39.9187 5.39879 39.9443 5.26422 39.9443 5.12829C39.9443 4.99237 39.9187 4.8578 39.8688 4.73241C39.819 4.60702 39.746 4.49331 39.6541 4.39788C39.5622 4.30245 39.4532 4.2272 39.3335 4.17652C39.2137 4.12584 39.0856 4.10073 38.9565 4.10266H5.84348ZM0.973913 8.20521C0.715623 8.20524 0.46792 8.3133 0.285281 8.50564C0.102643 8.69798 2.58251e-05 8.95884 0 9.23085V40C2.58251e-05 40.272 0.102643 40.5329 0.285281 40.7252C0.46792 40.9175 0.715623 41.0256 0.973913 41.0256H43.8261C44.0844 41.0256 44.3321 40.9175 44.5147 40.7252C44.6974 40.5329 44.8 40.272 44.8 40V9.23085C44.8 8.95884 44.6974 8.69798 44.5147 8.50564C44.3321 8.3133 44.0844 8.20524 43.8261 8.20521H0.973913ZM1.94783 10.2565H42.8522V38.9744H1.94783V10.2565ZM22.4 15.3847C21.616 15.3847 21.4261 15.8657 21.4261 16.4103V25.6411C21.4261 26.7857 21.4261 27.6923 19.4783 27.6923C16.6987 27.6923 15.5826 28.9405 15.5826 30.7693C15.5826 32.001 15.8222 33.8462 19.4783 33.8462C23.1343 33.8462 23.3739 31.1303 23.3739 29.7436V21.5746C23.3739 20.8638 23.4294 20.5129 23.8228 20.5129C25.0782 20.5129 25.0783 21.5385 28.2435 21.5385C28.2435 21.5385 29.2174 21.5385 29.2174 20.5129V17.436C29.2174 16.6667 28.8678 16.4103 28.2435 16.4103C25.0783 16.4103 25.3217 15.3847 22.4 15.3847Z"
                  fill="white"
                />
              </svg>

              <p class="text-light mt-2 mb-1 nav-text">My Library</p>
            </b-button>
            <b-button
              variant="link"
              style="text-decoration:none;"
              :to="{
                name: 'LibraryArea',
                params: { area: 'create', name: 'Library' },
              }"
              v-if="whatUserType() === 'discover' && isAuthenticated"
            >
              <!-- TODO: install webpack to use some svg extractor -->
              <svg
                class="nav-icon"
                viewBox="0 0 45 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-bind:class="{
                  'c-selected-menu':
                    this.$route.name && this.$route.name.includes('Library'),
                }"
              >
                <path
                  d="M10.713 0.000102571C10.584 -0.00181952 10.4559 0.0232894 10.3361 0.0739701C10.2163 0.124651 10.1073 0.199892 10.0154 0.295322C9.92352 0.390752 9.85054 0.504467 9.80073 0.629859C9.75091 0.755251 9.72526 0.889818 9.72526 1.02574C9.72526 1.16166 9.75091 1.29623 9.80073 1.42162C9.85054 1.54701 9.92352 1.66073 10.0154 1.75616C10.1073 1.85159 10.2163 1.92683 10.3361 1.97751C10.4559 2.02819 10.584 2.0533 10.713 2.05138H34.087C34.216 2.0533 34.3441 2.02819 34.4639 1.97751C34.5837 1.92683 34.6927 1.85159 34.7846 1.75616C34.8765 1.66073 34.9495 1.54701 34.9993 1.42162C35.0491 1.29623 35.0747 1.16166 35.0747 1.02574C35.0747 0.889818 35.0491 0.755251 34.9993 0.629859C34.9495 0.504467 34.8765 0.390752 34.7846 0.295322C34.6927 0.199892 34.5837 0.124651 34.4639 0.0739701C34.3441 0.0232894 34.216 -0.00181952 34.087 0.000102571H10.713ZM5.84348 4.10266C5.71442 4.10073 5.58629 4.12584 5.46653 4.17652C5.34677 4.2272 5.23777 4.30245 5.14586 4.39788C5.05396 4.49331 4.98097 4.60702 4.93116 4.73241C4.88135 4.8578 4.85569 4.99237 4.85569 5.12829C4.85569 5.26422 4.88135 5.39879 4.93116 5.52418C4.98097 5.64957 5.05396 5.76328 5.14586 5.85871C5.23777 5.95414 5.34677 6.02939 5.46653 6.08007C5.58629 6.13075 5.71442 6.15586 5.84348 6.15393H38.9565C39.0856 6.15586 39.2137 6.13075 39.3335 6.08007C39.4532 6.02939 39.5622 5.95414 39.6541 5.85871C39.746 5.76328 39.819 5.64957 39.8688 5.52418C39.9187 5.39879 39.9443 5.26422 39.9443 5.12829C39.9443 4.99237 39.9187 4.8578 39.8688 4.73241C39.819 4.60702 39.746 4.49331 39.6541 4.39788C39.5622 4.30245 39.4532 4.2272 39.3335 4.17652C39.2137 4.12584 39.0856 4.10073 38.9565 4.10266H5.84348ZM0.973913 8.20521C0.715623 8.20524 0.46792 8.3133 0.285281 8.50564C0.102643 8.69798 2.58251e-05 8.95884 0 9.23085V40C2.58251e-05 40.272 0.102643 40.5329 0.285281 40.7252C0.46792 40.9175 0.715623 41.0256 0.973913 41.0256H43.8261C44.0844 41.0256 44.3321 40.9175 44.5147 40.7252C44.6974 40.5329 44.8 40.272 44.8 40V9.23085C44.8 8.95884 44.6974 8.69798 44.5147 8.50564C44.3321 8.3133 44.0844 8.20524 43.8261 8.20521H0.973913ZM1.94783 10.2565H42.8522V38.9744H1.94783V10.2565ZM22.4 15.3847C21.616 15.3847 21.4261 15.8657 21.4261 16.4103V25.6411C21.4261 26.7857 21.4261 27.6923 19.4783 27.6923C16.6987 27.6923 15.5826 28.9405 15.5826 30.7693C15.5826 32.001 15.8222 33.8462 19.4783 33.8462C23.1343 33.8462 23.3739 31.1303 23.3739 29.7436V21.5746C23.3739 20.8638 23.4294 20.5129 23.8228 20.5129C25.0782 20.5129 25.0783 21.5385 28.2435 21.5385C28.2435 21.5385 29.2174 21.5385 29.2174 20.5129V17.436C29.2174 16.6667 28.8678 16.4103 28.2435 16.4103C25.0783 16.4103 25.3217 15.3847 22.4 15.3847Z"
                  fill="white"
                />
              </svg>

              <p class="text-light mt-2 mb-1 nav-text">My Library</p>
            </b-button>
          </b-col>
          <b-col cols="4">
            <b-button
              variant="link"
              style="text-decoration:none;"
              :to="{ name: 'Dashboard' }"
              v-if="whatUserType() === 'creator' && isAuthenticated"
            >
              <!-- TODO: install webpack to use some svg extractor -->
              <svg
                class="nav-icon"
                width="36"
                height="28"
                viewBox="0 0 36 28"
                fill="none"
                v-bind:class="{
                  'c-selected-menu': this.$route.name == 'Dashboard',
                }"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.83019 10.3209L1.98113 18.1699L9.83019 26.019L17.6792 18.1699L9.83019 10.3209ZM1 18.1699L9.83019 27.0001L18.6604 18.1699L9.83019 9.33973L1 18.1699Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.17 1.98102L10.321 9.83008L18.17 17.6791L26.0191 9.83008L18.17 1.98102ZM9.33984 9.83008L18.17 18.6603L27.0002 9.83008L18.17 0.999889L9.33984 9.83008Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.5094 10.3209L18.6603 18.1699L26.5094 26.019L34.3584 18.1699L26.5094 10.3209ZM17.6792 18.1699L26.5094 27.0001L35.3396 18.1699L26.5094 9.33973L17.6792 18.1699Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
              </svg>
              <p class="text-light mt-2 mb-1 nav-text">Back Stage Management</p>
            </b-button>
            <b-button
              variant="link"
              style="text-decoration:none;"
              :to="{ name: 'Home' }"
              v-if="whatUserType() === 'discover' && isAuthenticated"
            >
              <!-- TODO: install webpack to use some svg extractor -->
              <svg
                class="nav-icon"
                width="36"
                height="28"
                viewBox="0 0 36 28"
                fill="none"
                v-bind:class="{ 'c-selected-menu': this.$route.name == 'Home' }"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.83019 10.3209L1.98113 18.1699L9.83019 26.019L17.6792 18.1699L9.83019 10.3209ZM1 18.1699L9.83019 27.0001L18.6604 18.1699L9.83019 9.33973L1 18.1699Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.17 1.98102L10.321 9.83008L18.17 17.6791L26.0191 9.83008L18.17 1.98102ZM9.33984 9.83008L18.17 18.6603L27.0002 9.83008L18.17 0.999889L9.33984 9.83008Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.5094 10.3209L18.6603 18.1699L26.5094 26.019L34.3584 18.1699L26.5094 10.3209ZM17.6792 18.1699L26.5094 27.0001L35.3396 18.1699L26.5094 9.33973L17.6792 18.1699Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
              </svg>
              <p class="text-light mt-2 mb-1 nav-text">Feed</p>
            </b-button>
          </b-col>
          <b-col cols="4">
            <b-button
              v-b-toggle.menu-sidebar
              variant="link"
              style="text-decoration:none;"
              class=""
              v-if="whatUserType() === 'discover' && isAuthenticated"
            >
              <img
                src="../assets/search-icon-white.svg"
                class="align-top nav-icon search-btn"
                alt="Menu"
              />
              <p class="text-light mt-2 mb-1 nav-text">Search</p>
            </b-button>
            <b-button
              :to="{ name: 'AccountSettings' }"
              variant="link"
              style="text-decoration:none;"
              class=""
              v-if="whatUserType() === 'creator' && isAuthenticated"
            >
              <img
                v-if="this.$route.name === 'AccountSettings'"
                src="../assets/account-highlighted.svg"
                class="align-top nav-icon"
                alt="Menu"
              />
              <img
                v-else
                src="../assets/account.svg"
                class="align-top nav-icon"
                alt="Menu"
              />
              <p class="text-light mt-2 mb-1 nav-text">My Account</p>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <chipinplus
      v-if="(getLoadedSongData.chipin_plus || getLoadedSongData.radio ) && getLoadedSongData.locked"
      v-bind:user_id="getLoadedSong.user_id"
      v-bind:username="getLoadedSong.username"
    ></chipinplus>

    <!-- <RadioSubscribe></RadioSubscribe> -->

  </b-row>

</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { Howl } from "howler"; // Howler
import { SongDataInfo } from "../services/SongDataEventBus";
import { eventPlayerDisplay } from "../services/PlayerDisplayEventBus";
// import player from './player.vue';

export default {
  // components: { player },
  props: ["playerIsShowed"],
  data: function() {
    return {
      seek: 0,
      player: null,
      dragging: false,
      barHover: false,
      dragSeek: null,
      barTapped: false,
      taps: 0,
      filledSectionEntered: false,
      expand: true,
      hidden: true,
      collapseTimer: null,
      player_timer: null,
      updateSeek: null,
      xsScreen: window.matchMedia("(max-width: 375px)").matches,
      selectedRoute: "",
      playlistBeingPlayed: null,
      radio_stopped: false,
    };
  },
  created: function() {},
  methods: {
    ...mapGetters(["whatUserType"]),
    ...mapMutations("Player", [
      "playSong",
      "pauseSong",
      "setSong",
      "resetPlayer",
      "hidePlayer",
      "nextSong",
      "previousSong",
      "setInitialPlay",
      "setPlayTime",
      "toggleShuffle",
      "toggleRepeat",
      "setRepeat",
      "unSetRepeat",
      "setShowLockedModal",
      "setPreviewStarted",
      "decrementSkips"
    ]),
    show_player() {
      let shouldShow = true;
      let displayPlayerStatus = "";

      if (this.expand) {
        displayPlayerStatus = "expanded";
      } else {
        displayPlayerStatus = "collapsed";
      }

      /*if (!this.isAuthenticated) {
        shouldShow = false;
        displayPlayerStatus = "hidden";
      }*/

      eventPlayerDisplay.$emit("onChangePlayerIsShowed", shouldShow);
      eventPlayerDisplay.$emit("onChangePlayerShowStatus", displayPlayerStatus);

      return shouldShow;
    },
    play: function() {
      if (this.player) {
        if (!this.player.playing()) {

          this.player.play();
          
          this.playSong();
          this.$store.dispatch("Player/startTimer");
        }
      }
    },
    showPlayerIfItsNotVisible: function() {
      this.hidden = false;
    },
    pause: function() {
      this.player.pause();
      this.pauseSong();
    },
    hide() {
      this.hidePlayer();
    },
    clickSeek: function(e) {
      if (!this.getLoadedSongData.radio) {
        var seekTo = Math.floor(
          (e.offsetX / e.target.offsetWidth) * this.player.duration()
        );

        if (this.player) {
          if (!this.dragging) {
            this.seek = seekTo;
            this.player.seek(seekTo);
          }
        }
      }
    },
    // Called when the cursor is moved
    // Calculate the seek point in seconds based on the click position on the player bar
    dragToSeek: function(e) {
      if (!this.getLoadedSongData.radio) {
        if (this.dragging) {
          var newSeek;
          if (e.target.id === "progress") {
            newSeek = Math.floor(
              (e.offsetX / e.target.offsetWidth) * this.player.duration()
            );
          }
          if (e.target.id === "progress-fill") {
            newSeek = Math.floor(
              (e.offsetX / e.target.parentElement.offsetWidth) *
                this.player.duration()
            );
          }

          this.dragSeek = newSeek;
        }
      }
    },
    detectMouseDown(e) {
      e.preventDefault();

      if (!this.getLoadedSongData.radio) {
        if (e.target.id === "progress") {
          this.dragSeek = Math.floor(
            (e.offsetX / e.target.offsetWidth) * this.player.duration()
          );
        }

        e.target.addEventListener("mousemove", this.dragToSeek, false);
        e.target.parentElement.addEventListener(
          "mousemove",
          this.dragToSeek,
          false
        );
        this.dragging = true;
      }
    },
    detectMouseUp(e) {
      if (!this.getLoadedSongData.radio) {
        if (this.dragging) {
          e.target.removeEventListener("mousemove", this.dragToSeek, false);
          e.target.parentElement.removeEventListener(
            "mousemove",
            this.dragToSeek,
            false
          );
          this.dragging = false;
          this.seek = this.dragSeek;
          this.player.seek(this.dragSeek);
        }
      }
    },
    barClick(e) {
      if (!this.getLoadedSongData.radio) {
        // Get click position on filled section
        var seekTo =
          (e.offsetX / e.target.parentElement.offsetWidth) *
          this.player.duration();
        this.player.seek(seekTo);
      }
    },
    tapSeek(e) {
      e.preventDefault();
      if (!this.getLoadedSongData.radio) {

        var vm = this;

        // First tap
        if (this.taps === 0) {
          this.barTapped = true;
          this.taps++;
          // If there is no 2nd tap within 3 seconds then shrink the progress bar again
          setTimeout(function() {
            if (vm.taps === 1) {
              vm.barTapped = false;
              vm.taps = 0;
            }
          }, 3000);
        }
        // Second tap
        else if (this.taps >= 1) {
          // Seek to position
          var xTapPos = e.changedTouches[0].clientX;
          var progressBarWidth;
          var seekTo;

          if (e.target.id === "progress") {
            progressBarWidth = e.target.offsetWidth;
          } else if (e.target.id === "progress-fill") {
            progressBarWidth = e.target.parentElement.offsetWidth;
          }

          seekTo = Math.floor(
            (xTapPos / progressBarWidth) * this.player.duration()
          );

          this.player.seek(seekTo);
          this.taps = 0;
          this.barTapped = false;
        }
      }
    },
    forward() {
      // If there is a player
      if (this.player) {

        if (this.getSongQueue.length <= 0) {
          this.pause();
          this.resetPlayer();
        }

        if (this.getLoadedSongData.radio) {

          this.decrementSkips();
          if (this.getRemainingSkips >= 0) {
            this.pause();
            this.nextSong();

            this.$store.dispatch("Player/track_play", { 
              song_id: this.getLoadedSong, 
              is_radio: this.getLoadedSongData.radio, 
              type: 'skip'
            } );
          }
          else {
            if (this.getLoadedSongData.locked) {
              this.$parent.$bvModal.show(
                "chipin-plus-modal-" + this.getLoadedSongData.user_id
              );
            }
          }
        }
        else {
          this.pause();
          this.nextSong();
        }

      }
    },
    back() {
      if (this.player && !this.getLoadedSongData.radio) {
        if (
          this.player.playing() &&
          this.$store.state.Player.previous.length == 0
        ) {
          this.player.seek(0);
        } else if (this.player.playing()) {
          this.pause();
          this.previousSong();
        } else {
          this.previousSong();
        }
      }
      if (this.player && this.getLoadedSongData.radio) {
        var previousSong = this.getPreviousQueue[0];

        if (previousSong.locked) {
          this.$parent.$bvModal.show(
            "chipin-plus-modal-" + previousSong.user_id
          );
        }
        else {
          if (
            this.player.playing() &&
            this.$store.state.Player.previous.length == 0
          ) {
            this.player.seek(0);
          } else if (this.player.playing()) {
            this.pause();
            this.previousSong();
          } else {
            this.previousSong();
          }
        }
      }
    },
    playerMouseEnter() {
      // this.expand = true;
      // clearTimeout(this.collapseTimer);
    },
    playerMouseLeave() {
      // var vm = this;
      // this.collapseTimer = setTimeout(function () {
      //   vm.expand = false;
      // }, 5000);
    },
    shuffle() {
      
      this.toggleShuffle();
    },
    repeat() {
      if (this.getRepeat) {
        this.unSetRepeat;
      }
      
      this.toggleRepeat();
    },

    radio_stop() {
      this.radio_stopped = true;
      this.pause();
      this.resetPlayer();
    },

    radio_restart() {
      this.radio_stopped = false;
      if (this.isAuthenticated) {
        this.$bvModal.show("radio-modal");
      } else {
        this.$bvModal.show("login-modal");
      }
    },

  },
  mounted: function() {
    SongDataInfo.$on("PlaylistIdIsBeingPlayed", (playlistData) => {
      this.playlistBeingPlayed = playlistData.playlistId;
    });

    /*
    document.addEventListener('keydown', e => {
      if (e.code === 'Space') { e.preventDefault() }
    })

    document.addEventListener('keyup', event => {
      
      if (event.code === 'Space') {
        if (this.playing) {
          this.pause();
        } else {
          this.play();
        }
      }
    })
    */

  },
  computed: {
    ...mapGetters(["isAuthenticated", "username"]),
    ...mapGetters("Player", {
      paused: "isPaused",
      playing: "isPlaying",
      loadedSong: "loadedSong",
      getLoadedSong: "getLoadedSong",
      getLoadedSongData: "getLoadedSongData",
      isSongLoaded: "isSongLoaded",
      playerHidden: "playerHidden",
      getSongQueue: "getSongQueue",
      getPreviousQueue: "getPreviousQueue",
      initialPlay: "isInitialPlay",
      playTime: "getPlayTime",
      playerTimer: "getPlayerTimer",
      isShuffled: "isShuffled",
      getRepeat: "getRepeat",
      getChipinPlus: "getChipinPlus",
      getUserId: "getUserId",
      isLocked: "isLocked",
      getUsername: "getUsername",
      showLockedModal: "showLockedModal",
      preview: "getPreview",
      modal_id: "getModalId",
      previewStarted: "getPreviewStarted",
      getRemainingSkips: "getRemainingSkips",
    }),

    // username() {
    //   return this.$store.state.player_data.username;
    // },
    progress() {
      if (!this.player) return 0;
      if (this.player.duration() === 0) return 0;
      return this.seek / this.player.duration();
    },
    trackProgress() {
      let executed = this.seek ? this.seek : 0;
      let total_duration = this.player ? this.player.duration() : 0;

      let assetId = this.playlistBeingPlayed
        ? this.playlistBeingPlayed
        : this.getLoadedSongData.id;

      SongDataInfo.$emit("songChanged__" + assetId, {
        executed,
        total_duration,
      });
      return this.progress * 100;
    },
    trackProgressDrag() {
      if (!this.player) return 0;
      return (this.dragSeek / this.player.duration()) * 100;
    },
    trackProgressMinutesSeconds() {
      let minutes = Math.floor(this.seek / 60);
      let seconds = Math.floor(this.seek % 60);
      // It ain't pretty but it works
      return `${minutes}:${seconds < 10 ? 0 : ""}${seconds}`;
    },
    getMaxTextLength() {
      /* Determine the max text length for the song name marquee
         Magic numbers determined from trial and error */
      if (window.matchMedia("(min-width: 1200px)").matches) {
        return 15;
      }
      if (window.matchMedia("(min-width: 992px)").matches) {
        return 26;
      }
      if (window.matchMedia("(min-width: 768px)").matches) {
        return 20;
      } else {
        return 15;
      }
    },
    getMaxArtistLength() {
      if (window.matchMedia("(min-width: 768px)").matches) {
        return 16;
      }
      if (window.matchMedia("(min-width: 576px)").matches) {
        return 13;
      } else {
        return 19;
      }
    },
  },
  watch: {
    isAuthenticated() {
      if (this.isAuthenticated) {
        this.resetPlayer()
      }
    },
    playing(playing) {
      if (this.getLoadedSongData.chipin_plus && this.getLoadedSongData.locked) { 
        this.setShowLockedModal(true);
      }
      if (this.player) {
        if (!this.player.playing()) {
          this.player.play();

          this.showPlayerIfItsNotVisible();

          //"Playing from playing()");
        }
        this.seek = this.player.seek();

        if (playing) {
          if (this.initialPlay) {
            // var vm = this;

            this.expand = true;
            // this.collapseTimer = setTimeout(function() {
            //   vm.expand = false;
            // }, 5000);
            this.setInitialPlay(false);
          }

          this.seek = this.player.seek();
          this.updateSeek = setInterval(() => {
            if (this.player) {
              this.seek = this.player.seek();
            } else {
              clearInterval(this.updateSeek);
            }
          }, 250);
        } else {
          clearInterval(this.updateSeek);
        }
      }
    },
    playSong() {
      if (this.player) {
        
        this.player.play();
        this.playSong();
        this.$store.dispatch("Player/stopTimer");
      } else {
        this.getLoadedSong();
      }
    },
    paused() {
      if (this.player) {
        if (this.paused) {
          this.player.pause();
          this.pauseSong();
          this.$store.dispatch("Player/stopTimer");
        }
      }
    },
    getLoadedSong() {
      if (this.getLoadedSongData.chipin_plus && this.getLoadedSongData.locked) {
        this.setShowLockedModal(true);
        this.$parent.$bvModal.show(
          "chipin-plus-modal-" + this.getLoadedSongData.user_id + "-" + this.getLoadedSongData.indexed
        );
      }
      // else if (this.player) {
      //   console.log("2")
      //   if (this.player.playing()) {
      //     this.player.pause();
      //   }
      // }
      if (!this.getLoadedSong) { this.pause(); this.resetPlayer(); this.player = null; }
      else if (this.getLoadedSong) {
        console.log(this.getLoadedSong === null)

        let v = this;

        this.player = new Howl({
          src: [this.getLoadedSongData.file],
          html5: true,
          onend: function() {
            //v.seek = 0;

            v.$store.dispatch("Player/stopTimer");
            if (v.preview) {
              if (v.isAuthenticated) {
                v.$bvModal.show(v.modal_id);
              } else {
                v.$bvModal.show('login-modal')
              }
              v.resetPlayer();
              v.pause();
              v.player = null;

            } else {
              if (!v.getRepeat && v.getSongQueue.length > 0) {
                v.nextSong();
              } else {
                v.resetPlayer();
                v.pause();
                v.player = null;
              }
            }

            v.$store.dispatch("Player/startTimer");
          },
        });

        /*if (this.preview) {
          this.player.play();
          this.setPreviewStarted(true)
        } else {
          this.player.play();
        }*/
        
        this.player.play();
        this.playSong();
        
        this.$store.dispatch("Player/startTimer");
      } else {
        //"not loaded song");
      }
    },
    playTime() {
      // When play timer reaches 0, increment play count
      if (this.playTime === 0 && this.username != this.getLoadedSongData.username) {
        this.$store.dispatch("Player/stopTimer");
        this.$store.dispatch("Player/track_play", { song_id: this.getLoadedSong, is_radio: this.getLoadedSongData.radio } );
      }
    },
  },
};
</script>

<style scoped>
.c-selected-menu path {
  fill: #e76e66;
  stroke: #e76e66;
}

.song-name {
  width: 31vw;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.17px;
  text-align: center;
}

.song-artist-name {
  width: 31vw;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0.17px;

}

.player-container {
  height: 50px;
  /* margin-left: 5px; */
  /* margin-right: 10px; */
}

.select-track {
  font-family: "Roboto";
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 25px;
  transform: translateY(50%);
}

.select-track-section {
  padding: 0;
}

.fade {
  /* -webkit-transition: all 2s ease-in-out;
        -moz-transition: all 2s ease-in-out;
        -o-transition: all 2s ease-in-out; */
  transition: all 2s ease-in;
}

.bar {
  height: 0.5rem;
  /* transition: all 1.5s ease-in-out; */
  background: rgba(216, 216, 216, 0.5); /* Green background with 30% opacity */
  /* background: #4A4A4A; */
}

.bar-hoverable:hover {
  height: 1.8rem;
  margin-top: -21px;
  transform: translateY(55%);
  /* transition: all 1.5s ease-in-out; */
}

.bar-expand {
  height: 1.8rem;
}

.bar-hide {
  height: 0rem;
  transition: all 1.5s ease-in-out;
}

.player-label-hide {
  font-size: 1em;
  opacity: 0;
  /* transition: all 0.1s ease-in-out; */
}

.player-label {
  font-size: 1em;
  font-weight: 400;
  opacity: 1;
  /* transition: all 0.1s ease-in-out; */
}

.small-player {
  margin-top: -10px;
  margin-left: 100px;
  width: 115px;
}

.player-expand {
  transform: translateY(0%);
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}

.player-collapse {
  /* transform: translateY(65%); */
  transform: translateY(45%); /* With bottom nav menu */
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}

.nav-text {
  font-size: 10px;
  font-weight: 400;
  line-height: 11.72px;
  text-align: center;
}

.search-btn.nav-icon {
  margin-top: 4px;
}

.nav-icon {
  height: 20px;
}

.nav-arrow {
  display: none;
}

.main-play-icon {
  height: 18px;
  /* margin-bottom: 22px; */
  transform: translate(0%, 65%);
}

.back-icon {
  height: 14px;
}

.forward-icon {
  height: 14px;
}

.shuffle-icon {
  width: 16px;
  transform: translateX(-100%);
}

.repeat-icon {
  width: 16px;
  transform: translateX(100%);
}

.player-control-left {
  padding: 0;
  transform: translateX(30%);
}

.player-control-right {
  padding: 0;
  transform: translateX(-30%);
}

.song-info {
  display: none;
}

.song-info-xs {
  display: block;
  transform: translateY(-40%);
  height: 25px;
}

.marquee {
  width: 150px;
  line-height: 50px;
  /* background-color: red; */
  color: white;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  transform: translate(30%, 5%);
}
.marquee div {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 15s linear infinite;
}
.marquee div span {
  padding-left: 10px;
}
.player-hidden {
  display: none;
}
@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}

@media (max-width: 576px) {
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .nav-margin {
    margin-left: 3em;
    margin-right: 3em;
  }

  .nav-text {
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;
  }

  .nav-arrow {
    display: inline;
    transform: translateY(-50%);
  }

  .song-name {
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.17px;
    text-align: center;
    width: 13.5em;
  }

  .song-artist-name {
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 35px;
    letter-spacing: 0.17px;
  }

  .song-info {
    display: flex;
    transform: translateY(-25%);
  }

  .song-info-adjust {
    transform: translateY(-20%);
  }

  .song-info-xs {
    display: none;
  }

  .nav-icon {
    height: 32px;
  }

  .player-container {
    height: 80px;
    margin-left: 50px;
    margin-right: 50px;
  }

  .main-play-icon {
    height: 22px;
    transform: translateY(0%);
  }

  .back-icon {
    height: 18px;
  }

  .forward-icon {
    height: 18px;
  }

  .player-container {
    height: 80px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .select-track {
    font-family: "Roboto";
    font-weight: 300;
    font-size: 18px;
    margin-bottom: 0px;
    transform: translateY(-30%);
  }

  .player-control-left {
    padding: 0;
    transform: translateX(0em);
  }

  .player-control-right {
    padding: 0;
    transform: translateX(0em);
  }

  .marquee {
    width: 6em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(15%, 0%);
  }
}

/*  Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .nav-margin {
    margin-left: 5em;
    margin-right: 5em;
  }

  .nav-icon {
    height: 27px;
  }

  .nav-arrow {
    display: inline;
  }

  .nav-text {
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;
  }

  .player-container {
    height: 80px;
    margin-left: 50px;
    margin-right: 50px;
  }

  .main-play-icon {
    height: 25px;
    transform: translateY(0%);
  }

  .player-container {
    height: 80px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .song-info {
    display: flex;
    margin-top: 10px;
    transform: translateY(-40%);
  }

  .song-info-xs {
    display: none;
  }

  .select-track {
    font-family: "Roboto";
    font-weight: 300;
    font-size: 24px;
    margin-bottom: 0px;
  }

  .marquee {
    width: 8em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(35%, -20%);
    margin-right: 0px;
  }

  .marquee-adjust {
    transform: translateY(-15%);
  }

  .artist-name-adjust {
    transform: translate(20%, -30%);
    padding: 0;
  }

  .player-control-left {
    transform: translateX(3em);
  }

  .player-control-right {
    transform: translateX(-3em);
  }
}

@media (min-width: 800px) {
  .marquee {
    width: 9em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(30%, -20%);
    margin-right: 0px;
  }
}

@media (min-width: 870px) {
  .marquee {
    width: 10em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(25%, -20%);
    margin-right: 0px;
  }
}

@media (min-width: 915px) {
  .marquee {
    width: 11em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(20%, -20%);
    margin-right: 0px;
  }
}

/*  Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .marquee {
    width: 10.5em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(15%, -20%);
    margin-right: 10px;
  }

  .artist-name-adjust {
    transform: translateY(-30%);
  }

  .main-play-icon {
    height: 30px;
    transform: translateY(5%);
  }

  .player-control-left {
    transform: translateX(3em);
  }

  .player-control-right {
    transform: translateX(-3em);
  }
}

@media (min-width: 1075px) {
  .marquee {
    width: 11em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(20%, -20%);
    margin-right: 10px;
  }
}

/*  Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .nav-margin {
    margin-left: 7em;
    margin-right: 7em;
  }

  .nav-icon {
    height: 27px;
  }

  .nav-arrow {
    display: inline;
    /* transform: translateY(-100%); */
  }

  .nav-text {
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;
  }

  .song-name {
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.17px;
    text-align: center;
    width: 11.5em;
  }

  .song-artist-name {
    font-size: 24px;
    font-style: normal;
    font-weight: 200;
    line-height: 35px;
    letter-spacing: 0.17px;
    width: fit-content;
  }

  .song-info {
    display: flex;
  }

  .song-info-adjust {
    margin-top: 15px;
    transform: translate(-4%, -50%);
  }

  .artist-name-adjust {
    transform: translateY(-30%);
  }

  .song-info-xs {
    display: none;
  }

  .player-container {
    height: 80px;
    margin-left: 50px;
    margin-right: 50px;
  }

  .main-play-icon {
    height: 30px;
    transform: translateY(5%);
  }

  .pause-icon {
    height: 30px;
    transform: translateY(20%);
  }

  .repeat-icon {
    margin-left: 20px;
    width: 21px;
  }

  .repeat-inactive-icon {
    margin-left: 20px;
    width: 21px;
  }

  .shuffle-icon {
    width: 22px;
  }

  .forward-icon {
    margin-left: 20px;
  }

  .player-container {
    height: 80px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .select-track {
    font-family: "Roboto";
    font-weight: 300;
    font-size: 24px;
    margin-bottom: 0px;
  }

  .marquee-margin {
    margin-left: -55px;
    /* transform: translateY(20%); */
  }

  .marquee {
    width: 6.5em;
    line-height: 50px;
    /* background-color: red; */
    color: white;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    transform: translate(30%, -20%);
  }

  .player-control-left {
    transform: translateX(5em);
  }

  .player-control-right {
    transform: translateX(-5em);
  }

  .player-width {
    width: 1200px;
  }
}

@media (max-width: 576px) {
  .main-play-icon {
    transform: none;
  }
}
</style>

